import Modal from 'app/components/layouts/Modals/Index';
import { useTranslation } from 'next-i18next';

const ModalDelete = ({ isOpen, onClose, title, handleDelete }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={title}
      show={isOpen} onClose={onClose}
      onConfirm={() => handleDelete()}
      type="warning"
      confirmButtonText={t('actions.delete')}
      cancelButtonText={t('commons.cancel')}
      showCancelButton={true}
      confirmButtonColor="#DD6B55"
      reverseButtons={true}
    >
    </Modal >
  )
}

export default ModalDelete
